import { WEBSITE_BUILDER_Z_LAYERS } from "pages/secure/facility/websiteBuilder/editor/utility/websiteBuilderZLayers";
import classNames from "classnames";
import React from "react";
import "./tableBuilderDropdown.scss";

type TTableBuilderDropdownAlignment = "left" | "right";

interface ITableBuilderDropdownOption {
  label: string;
  disabled?: boolean;
  onClick: () => void;
}

export type TTableBuilderDropdownOptionSections = Array<Array<ITableBuilderDropdownOption>>;

interface ITableBuilderDropdownProps {
  alignment: TTableBuilderDropdownAlignment;
  open: boolean;
  sections: TTableBuilderDropdownOptionSections;
  toggleDropdown: () => void;
  children: JSX.Element;
}

export function TableBuilderDropdown(props: ITableBuilderDropdownProps) {
  const { alignment, open, sections, toggleDropdown, children } = props;
  
  return (
    <div
      className="table-builder-dropdown"
      style={{
        zIndex: WEBSITE_BUILDER_Z_LAYERS.designSpace.containerBuilderUI,
      }}
    >
      <div onClick={toggleDropdown}>
        {children}
      </div>
      <div
        className={classNames("table-builder-dropdown-content", {
          "dropdown-content-left-align": alignment === "left",
          "dropdown-content-right-align": alignment === "right",
        })}
        style={{
          display: open && sections?.length > 0 ? "block" : "none",
        }}
      >
        {sections.map((section, index) => {
          return (
            <React.Fragment key={index}>
              <div className="table-builder-dropdown-content-section">
                {section
                  .map((option, optionIndex) => {
                    return (
                      <button
                        key={optionIndex}
                        className="table-builder-dropdown-content-section-option"
                        onClick={option.onClick}
                        disabled={option.disabled}
                      >
                        {option.label}
                      </button>
                    );
                  })}
              </div>
              {index < sections.length - 1 && <hr className="table-builder-dropdown-content-section-divider" />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}